module.exports = __webpack_public_path__ + "static/media/RestingPosition.70f342fe.jpg";